// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_taskItem__CXctf {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 6px;
  border-radius: 12px;
  transition: all 0.2s ease;
  cursor: pointer;
}
.styles_taskItem__CXctf:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}
.styles_taskItem__CXctf.styles_completed__VdZ0y {
  opacity: 0.6;
}
.styles_taskItem__CXctf.styles_completed__VdZ0y .styles_taskTitle__NP-5W {
  text-decoration: line-through;
  color: var(--color-text-secondary);
}
.styles_taskItem__CXctf.styles_animating__OA5Lc {
  transform: scale(0.98);
}
.styles_taskItem__CXctf.styles_expanded__CVrSp {
  padding: 16px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 20px;
}

.styles_checkbox__uV9o8 {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.5);
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
  margin-top: 2px;
}
.styles_checkbox__uV9o8:hover {
  border-color: rgba(0, 0, 0, 0.7);
  background: rgba(0, 0, 0, 0.03);
}
.styles_checkbox__uV9o8:active {
  transform: scale(0.95);
}
.styles_checkbox__uV9o8.styles_checked__8goKq {
  border-color: transparent;
  background: transparent;
}
.styles_checkbox__uV9o8.styles_checked__8goKq:hover {
  background: transparent;
}

.styles_checkIcon__MPSBW {
  width: 18px;
  height: 18px;
  color: rgba(0, 0, 0, 0.5);
  stroke-width: 2.5;
}

.styles_taskContent__uIFeZ {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.styles_taskTitle__NP-5W {
  font: var(--typography-body-m-regular);
  color: var(--color-text-primary);
  line-height: 1.4;
}

.styles_taskTime__PH7gV {
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
  font-size: 12px;
}

.styles_taskHeader__0cfCD {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.styles_taskIcons__QlKsn {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.styles_chevron__tjGGp {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
  color: rgba(0, 0, 0, 0.5);
}
.styles_chevron__tjGGp.styles_chevronExpanded__QVd6W {
  transform: rotate(180deg);
}

.styles_editButton__wEukN {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  color: rgba(0, 0, 0, 0.5);
}
.styles_editButton__wEukN:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.8);
}
.styles_editButton__wEukN:active {
  transform: scale(0.95);
}

.styles_editIcon__m33bt {
  width: 14px;
  height: 14px;
}

.styles_taskDescription__rotRC {
  margin-top: 8px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
  line-height: 1.5;
  white-space: pre-wrap;
}

.styles_editMode__VdrDr {
  width: 100%;
  padding: 8px 0;
}

.styles_editField__977hU {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}
.styles_editField__977hU label {
  font: var(--typography-body-s-medium);
  color: var(--color-text-primary);
  font-size: 13px;
}
.styles_editField__977hU input,
.styles_editField__977hU textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  font: var(--typography-body-m-regular);
  color: var(--color-text-primary);
  background: white;
  transition: all 0.2s ease;
  resize: vertical;
}
.styles_editField__977hU input:focus,
.styles_editField__977hU textarea:focus {
  outline: none;
  border-color: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
}
.styles_editField__977hU input::placeholder,
.styles_editField__977hU textarea::placeholder {
  color: rgba(0, 0, 0, 0.3);
}
.styles_editField__977hU input.styles_inputError__u695X,
.styles_editField__977hU textarea.styles_inputError__u695X {
  border-color: #dc3545;
}
.styles_editField__977hU input.styles_inputError__u695X:focus,
.styles_editField__977hU textarea.styles_inputError__u695X:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
.styles_editField__977hU textarea {
  min-height: 80px;
  font-family: inherit;
}

.react-datepicker-wrapper {
  width: 100%;
}

.styles_editField__977hU .react-datepicker__input-container {
  width: 100%;
}
.styles_editField__977hU .react-datepicker__input-container input {
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  font: var(--typography-body-m-regular);
  color: var(--color-text-primary);
  background: white;
  transition: all 0.2s ease;
}
.styles_editField__977hU .react-datepicker__input-container input:focus {
  outline: none;
  border-color: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
}

.styles_errorText__DBi90 {
  font-size: 12px;
  color: #dc3545;
  margin-top: -4px;
}

.styles_editActions__VVrfu {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  justify-content: flex-end;
}
.styles_editActions__VVrfu button {
  padding: 8px 16px;
  border-radius: 12px;
  font: var(--typography-body-m-medium);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}
.styles_editActions__VVrfu button:active {
  transform: scale(0.98);
}

.styles_cancelButton__RjXEL {
  background: rgba(0, 0, 0, 0.05);
  color: var(--color-text-primary);
}
.styles_cancelButton__RjXEL:hover {
  background: rgba(0, 0, 0, 0.1);
}

.styles_saveButton__XOHPd {
  background: rgba(0, 0, 0, 0.9);
  color: white;
}
.styles_saveButton__XOHPd:hover {
  background: rgb(0, 0, 0);
}`, "",{"version":3,"sources":["webpack://./src/components/task-item/styles.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAAF;AAEE;EACE,yCAAA;EACA,2BAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAGI;EACE,6BAAA;EACA,kCAAA;AADN;AAKE;EACE,sBAAA;AAHJ;AAME;EACE,aAAA;EACA,+BAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;AALF;AAOE;EACE,gCAAA;EACA,+BAAA;AALJ;AAQE;EACE,sBAAA;AANJ;AASE;EACE,yBAAA;EACA,uBAAA;AAPJ;AASI;EACE,uBAAA;AAPN;;AAYA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;AATF;;AAYA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AATF;;AAYA;EACE,sCAAA;EACA,gCAAA;EACA,gBAAA;AATF;;AAYA;EACE,sCAAA;EACA,kCAAA;EACA,eAAA;AATF;;AAaA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,yBAAA;AAVF;AAYE;EACE,yBAAA;AAVJ;;AAcA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAXF;AAaE;EACE,+BAAA;EACA,yBAAA;AAXJ;AAcE;EACE,sBAAA;AAZJ;;AAgBA;EACE,WAAA;EACA,YAAA;AAbF;;AAgBA;EACE,eAAA;EACA,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,sCAAA;EACA,kCAAA;EACA,gBAAA;EACA,qBAAA;AAbF;;AAiBA;EACE,WAAA;EACA,cAAA;AAdF;;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAdF;AAgBE;EACE,qCAAA;EACA,gCAAA;EACA,eAAA;AAdJ;AAiBE;;EAEE,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,mBAAA;EACA,sCAAA;EACA,gCAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AAfJ;AAiBI;;EACE,aAAA;EACA,gCAAA;EACA,yCAAA;AAdN;AAiBI;;EACE,yBAAA;AAdN;AAiBI;;EACE,qBAAA;AAdN;AAgBM;;EACE,qBAAA;EACA,4CAAA;AAbR;AAkBE;EACE,gBAAA;EACA,oBAAA;AAhBJ;;AAqBA;EACE,WAAA;AAlBF;;AAsBE;EACE,WAAA;AAnBJ;AAqBI;EACE,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,mBAAA;EACA,sCAAA;EACA,gCAAA;EACA,iBAAA;EACA,yBAAA;AAnBN;AAqBM;EACE,aAAA;EACA,gCAAA;EACA,yCAAA;AAnBR;;AAyBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;AAtBF;AAwBE;EACE,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAtBJ;AAwBI;EACE,sBAAA;AAtBN;;AA2BA;EACE,+BAAA;EACA,gCAAA;AAxBF;AA0BE;EACE,8BAAA;AAxBJ;;AA4BA;EACE,8BAAA;EACA,YAAA;AAzBF;AA2BE;EACE,wBAAA;AAzBJ","sourcesContent":["@import \"mixins\";\n.taskItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 6px;\n  border-radius: 12px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n\n  &:hover {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n    transform: translateY(-1px);\n  }\n\n  &.completed {\n    opacity: 0.6;\n\n    .taskTitle {\n      text-decoration: line-through;\n      color: var(--color-text-secondary);\n    }\n  }\n\n  &.animating {\n    transform: scale(0.98);\n  }\n\n  &.expanded {\n    padding: 16px;\n    background: rgba(0, 0, 0, 0.02);\n    border-radius: 20px;\n  }\n}\n\n.checkbox {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid rgba(0, 0, 0, 0.5);\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  padding: 0;\n  margin-top: 2px;\n\n  &:hover {\n    border-color: rgba(0, 0, 0, 0.7);\n    background: rgba(0, 0, 0, 0.03);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  &.checked {\n    border-color: transparent;\n    background: transparent;\n\n    &:hover {\n      background: transparent;\n    }\n  }\n}\n\n.checkIcon {\n  width: 18px;\n  height: 18px;\n  color: rgba(0, 0, 0, 0.5);\n  stroke-width: 2.5;\n}\n\n.taskContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.taskTitle {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-primary);\n  line-height: 1.4;\n}\n\n.taskTime {\n  font: var(--typography-body-s-regular);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n}\n\n// Expanded state styles\n.taskHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n}\n\n.taskIcons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.chevron {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n  color: rgba(0, 0, 0, 0.5);\n\n  &.chevronExpanded {\n    transform: rotate(180deg);\n  }\n}\n\n.editButton {\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  color: rgba(0, 0, 0, 0.5);\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.05);\n    color: rgba(0, 0, 0, 0.8);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n}\n\n.editIcon {\n  width: 14px;\n  height: 14px;\n}\n\n.taskDescription {\n  margin-top: 8px;\n  padding: 12px;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 12px;\n  font: var(--typography-body-s-regular);\n  color: var(--color-text-secondary);\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n// Edit mode styles\n.editMode {\n  width: 100%;\n  padding: 8px 0;\n}\n\n.editField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 12px;\n\n  label {\n    font: var(--typography-body-s-medium);\n    color: var(--color-text-primary);\n    font-size: 13px;\n  }\n\n  input,\n  textarea {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1.5px solid rgba(0, 0, 0, 0.15);\n    border-radius: 12px;\n    font: var(--typography-body-m-regular);\n    color: var(--color-text-primary);\n    background: white;\n    transition: all 0.2s ease;\n    resize: vertical;\n\n    &:focus {\n      outline: none;\n      border-color: rgba(0, 0, 0, 0.4);\n      box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);\n    }\n\n    &::placeholder {\n      color: rgba(0, 0, 0, 0.3);\n    }\n\n    &.inputError {\n      border-color: #dc3545;\n\n      &:focus {\n        border-color: #dc3545;\n        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n      }\n    }\n  }\n\n  textarea {\n    min-height: 80px;\n    font-family: inherit;\n  }\n}\n\n// DatePicker wrapper - ensure full width\n:global(.react-datepicker-wrapper) {\n  width: 100%;\n}\n\n.editField {\n  :global(.react-datepicker__input-container) {\n    width: 100%;\n\n    input {\n      width: 100%;\n      padding: 10px 12px;\n      border: 1.5px solid rgba(0, 0, 0, 0.15);\n      border-radius: 12px;\n      font: var(--typography-body-m-regular);\n      color: var(--color-text-primary);\n      background: white;\n      transition: all 0.2s ease;\n\n      &:focus {\n        outline: none;\n        border-color: rgba(0, 0, 0, 0.4);\n        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);\n      }\n    }\n  }\n}\n\n.errorText {\n  font-size: 12px;\n  color: #dc3545;\n  margin-top: -4px;\n}\n\n.editActions {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n  justify-content: flex-end;\n\n  button {\n    padding: 8px 16px;\n    border-radius: 12px;\n    font: var(--typography-body-m-medium);\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n\n    &:active {\n      transform: scale(0.98);\n    }\n  }\n}\n\n.cancelButton {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--color-text-primary);\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.1);\n  }\n}\n\n.saveButton {\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n\n  &:hover {\n    background: rgba(0, 0, 0, 1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"taskItem": `styles_taskItem__CXctf`,
	"completed": `styles_completed__VdZ0y`,
	"taskTitle": `styles_taskTitle__NP-5W`,
	"animating": `styles_animating__OA5Lc`,
	"expanded": `styles_expanded__CVrSp`,
	"checkbox": `styles_checkbox__uV9o8`,
	"checked": `styles_checked__8goKq`,
	"checkIcon": `styles_checkIcon__MPSBW`,
	"taskContent": `styles_taskContent__uIFeZ`,
	"taskTime": `styles_taskTime__PH7gV`,
	"taskHeader": `styles_taskHeader__0cfCD`,
	"taskIcons": `styles_taskIcons__QlKsn`,
	"chevron": `styles_chevron__tjGGp`,
	"chevronExpanded": `styles_chevronExpanded__QVd6W`,
	"editButton": `styles_editButton__wEukN`,
	"editIcon": `styles_editIcon__m33bt`,
	"taskDescription": `styles_taskDescription__rotRC`,
	"editMode": `styles_editMode__VdrDr`,
	"editField": `styles_editField__977hU`,
	"inputError": `styles_inputError__u695X`,
	"errorText": `styles_errorText__DBi90`,
	"editActions": `styles_editActions__VVrfu`,
	"cancelButton": `styles_cancelButton__RjXEL`,
	"saveButton": `styles_saveButton__XOHPd`
};
export default ___CSS_LOADER_EXPORT___;
